import * as React from "react";
import * as ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";
import { App } from "./App";
import {
  Hub_Flipper,
  Hub_InteractiveTable,
  Hub_InteractiveTraining,
  Hub_ThreeCircles,
  Hub_QuickWins,
} from "./components";
import { theme } from "./theme";

import { GlobalUserProvider } from "./state";
import "./styles/main.scss";

declare const global: {
  React: typeof React;
  ReactDOM: typeof ReactDOM;
  WorkplaceHubComponents: {
    Hub_Flipper: typeof Hub_Flipper;
    Hub_InteractiveTable: typeof Hub_InteractiveTable;
    Hub_InteractiveTraining: typeof Hub_InteractiveTraining;
    Hub_ThreeCircles: typeof Hub_ThreeCircles;
    Hub_QuickWins: typeof Hub_QuickWins;
  };
};

global.React = React;
global.ReactDOM = ReactDOM;
global.WorkplaceHubComponents = {
  Hub_Flipper,
  Hub_InteractiveTable,
  Hub_InteractiveTraining,
  Hub_ThreeCircles,
  Hub_QuickWins,
};

const Providers: React.FC<{}> = ({ children }) => {
  return <GlobalUserProvider>{children}</GlobalUserProvider>;
};

const root = document.getElementById("root");

if (root) {
  ReactDOM.render(
    <React.StrictMode>
      <Providers>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Providers>
    </React.StrictMode>,
    root,
  );
}
